export default __webpack_public_path__ + "static/media/Component 49 – 1@2x.60a6d25c.png";